/**
 * @desc 平台名称查询平台信息
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<defs.basics.PlatformResponseDto>;
export function request(plarformName: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/platform/byName/${plarformName}`, {
      method: "GET",

      ...options,
    }),
  );
}
